import { defaultDashboardPath } from "@dashboard/routes/dashboard-navigation"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { dashboardAppHostRedirectUrl } from "@utils/dashboard-host"
import { currentRequestHostname } from "@utils/dashboard-host-runtime"

export const Route = createFileRoute("/dashboard")({
  component: Outlet,
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })

    const normalizedPathname = location.pathname.replace(/\/+$/, "") || "/"
    if (normalizedPathname === "/dashboard") {
      throw redirect({ href: defaultDashboardPath })
    }
  },
})
